import React from 'react';
import { Stack, FormControl, TextField, MenuItem, Typography, Chip, CircularProgress } from '@mui/material';
import { GroupsOutlined } from '@mui/icons-material';

interface Team {
  id: string;
  name: string;
  memberCount: number;
}

interface TeamSelectorProps {
  value: string;
  teams: Team[] | undefined;
  isLoading: boolean;
  onChange: (teamId: string) => void;
  error?: boolean;
  helperText?: string;
}

export const TeamSelector: React.FC<TeamSelectorProps> = ({ value, teams, isLoading, onChange, error = false, helperText }) => (
  <FormControl size="small">
    {isLoading ? (
      <TextField
        label="Target Team"
        size="small"
        disabled
        value=""
        InputProps={{ endAdornment: <CircularProgress size={20} /> }}
      />
    ) : (
      <TextField
        select
        label="Target Team"
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        helperText={helperText}
      >
        <MenuItem value="">
          <em>Select a team...</em>
        </MenuItem>
        {teams?.map((team) => (
          <MenuItem key={team.id} value={team.id}>
            <Stack direction="row" spacing={1} alignItems="center">
              <GroupsOutlined sx={{ fontSize: 16, color: '#64748b' }} />
              <Typography variant="body2">{team.name}</Typography>
              <Chip label={`${team.memberCount} members`} size="small" variant="outlined" />
            </Stack>
          </MenuItem>
        ))}
      </TextField>
    )}
  </FormControl>
);
